import { post } from '../request';
import { getToken } from '../store/auth';

/**
 * POST /calls/originate {number}：点击拨号——
 * 先呼本人坐席软电话（振铃），接听后再呼出到客户号码。
 */
export function originate(number: string): Promise<{ uuid: string }> {
  return post('/calls/originate', { number });
}

/**
 * POST /calls/hangup：坐席主动挂断（工作台通话中「挂断」）。
 * 必须由后端执行——后端会在挂断坐席腿**之前**把客户腿转入满意度（客户腿尚存时）；
 * 前端直发引擎挂断会让引擎在坐席腿挂断瞬间销毁客户腿，坐席先挂的邀评不可达。
 * 幂等：无在途通话返回 hung_legs=0。超时设短（4s），失败由调用方回退直连引擎挂断。
 */
export function hangupAgentCall(): Promise<{ hung_legs: number; surveyed: number }> {
  return post('/calls/hangup', {}, { timeout: 4000 });
}

/**
 * POST /calls/assist-hold {hold}：保持时停客户腿 ASR fork，恢复时还原。
 * 失败静默（转写中断不阻断话务条操作）。
 */
export function setAssistHold(hold: boolean): Promise<{ ok: boolean }> {
  return post('/calls/assist-hold', { hold }, { silent: true, timeout: 4000 });
}

/**
 * 坐席页面卸载主动放弃本通（刷新 / 关页 / 关标签），**仅限 pagehide 调用**：
 * 软电话媒体会话随页面销毁，本通必然中断；必须让服务端立刻挂断坐席腿，
 * 否则坐席可能卡在「通话中」且语音在服数不归还 → 后续呼叫不再派单。
 *
 * 请求一元化的例外（见 `docs/conventions/frontend.md` §3）：卸载时机只有 fetch keepalive
 * 能保证请求真正发出（XHR/axios 无 keepalive 语义，页面销毁即取消），故此处直接 fetch，
 * 路径与鉴权头与 `request.ts` 保持一致（同源 `/api/v1` + Bearer）。
 * 幂等且静默：无在途通话时服务端返回 hung_legs=0。
 */
export function abandonAgentCallOnUnload(): void {
  const token = getToken();
  if (!token) return;
  try {
    void fetch('/api/v1/calls/abandon', {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: '{}',
    });
  } catch {
    /* 卸载中：请求是否送达不影响离开，服务端另有对账兜底 */
  }
}
